import AvgGuestSpend from './AvgGuestSpend';
export default AvgGuestSpend;